import { Box, List, ListItem, ListItemText, Typography } from "@mui/material";
import { mdiGiftOutline } from "@mdi/js";
import Icon from "@mdi/react";
import LinkifyContainer from "components/LinkifyContainer";
import useBoundStore from "store";
import LocalStorage from "services/LocalStorage";

export interface WishlistProps {
  items: string[];
}

export default function Wishlist(props: WishlistProps) {
  const { items } = props;
  const externalLinkNavigation = useBoundStore((state) => state.generalSettings.externalLinkNavigation);
  const localStorage = LocalStorage.getInstance();
  const alreadySeenLinks = localStorage.getAllowedExternalLinks();

  function handleConfirmNavigation(clickedLink: string | null): void {
    if (clickedLink) {
      localStorage.setAllowedExternalLinks(clickedLink);
      window.open(clickedLink, "_blank")?.focus();
    }
  }

  return (
    <Box>
      <List sx={{ border: 1, borderRadius: 2, borderColor: "primary.main" }}>
        {items.map((item, index) => (
          <ListItem key={item}>
            <Box color='primary.main' display='flex' alignItems='center'>
              <Icon path={mdiGiftOutline} size={0.8} />
            </Box>
            <Typography ml={0.75} mr={2} component='span'>
              {index + 1}.
            </Typography>

            <ListItemText
              primary={
                <LinkifyContainer
                  alreadySeenLinks={alreadySeenLinks}
                  confirmNavigation={externalLinkNavigation}
                  onConfirmNavigation={handleConfirmNavigation}
                >
                  {item}
                </LinkifyContainer>
              }
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
}
